module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-actions', {
    staticClass: "py-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_vm._l((_vm.rollenGruppe), function(rollen, key, rolleIndex) {
    return _c('v-menu', {
      key: rolleIndex,
      attrs: {
        "close-on-click": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "text": ""
            }
          }, 'v-btn', attrs, false), on), [_vm._v(_vm._s(key)), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', _vm._l((rollen), function(rolle, rolleIndex) {
      return _c('v-list-item', {
        key: rolleIndex,
        on: {
          "click": function($event) {
            _vm.selectedSeite = rolle
          }
        }
      }, [_c('v-list-item-title', [_vm._v(_vm._s(rolle.titel))])], 1)
    }), 1)], 1)
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.addRolle()
      }
    }
  }, [_vm._v("Neue Rolle")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": _vm.deleteRolle
    }
  }, [_c('v-icon', [_vm._v("delete")]), _vm._v("Seite löschen")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2 primary",
    on: {
      "click": function($event) {
        return _vm.saveRollen()
      }
    }
  }, [_vm._v("Speichern")])], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    staticClass: "pa-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" Allgemein ")]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Bezeichnung"
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "200px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help")])]
            }
          }])
        }, [_vm._v("\n                      Die Bezeichnung der Rolle. Diese wird in der Navigation angezeigt.\n                    ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.selectedSeite.titel),
      callback: function($$v) {
        _vm.$set(_vm.selectedSeite, "titel", $$v)
      },
      expression: "selectedSeite.titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "items": ['Chargen', 'AHV', 'HBV', 'Ämter', 'Kommissionen', 'Zirkel'],
      "label": "Gruppe"
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "200px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help")])]
            }
          }])
        }, [_vm._v("\n                      Rollen können gruppiert werden. In der Rollenübersicht oder den Widgets können dann die\n                      Rollenverteilung nach Gruppe angezeigt werden.\n                    ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.selectedSeite.gruppe),
      callback: function($$v) {
        _vm.$set(_vm.selectedSeite, "gruppe", $$v)
      },
      expression: "selectedSeite.gruppe"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.bundesbruderselect,
      "outlined": "",
      "chips": "",
      "deletable-chips": "",
      "label": "Berechtigt",
      "multiple": "",
      "dense": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "200px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help")])]
            }
          }])
        }, [_vm._v("\n                      Die eingetragenen Personen können auf das Modul zugreifen.\n                    ")])]
      },
      proxy: true
    }, {
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          staticClass: "mt-1",
          attrs: {
            "small": "",
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click": data.select,
            "click:close": function($event) {
              return _vm.removeBerechtigung(data.item.value)
            }
          }
        }, [_vm._v("\n                      " + _vm._s(data.item.text) + "\n                    ")])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-content', [_c('v-list-item-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.text)
          }
        })], 1)]
      }
    }]),
    model: {
      value: (_vm.selectedSeite.berechtigt),
      callback: function($$v) {
        _vm.$set(_vm.selectedSeite, "berechtigt", $$v)
      },
      expression: "selectedSeite.berechtigt"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-avatar', {
    staticClass: "mr-4",
    attrs: {
      "size": 32,
      "color": "transparent"
    }
  }, [_c('img', {
    attrs: {
      "src": '/static/menu-icon/' + _vm.selectedSeite.bild + '.png'
    }
  })]), _vm._v(" "), _c('v-select', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "items": [
        'wappen',
        'AHV',
        'HBV',
        'Senior',
        'Consenior',
        'Fuxmajor',
        'Schriftfuhrer',
        'Kassierer',
        'Bierwart' ],
      "label": "Bild"
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "200px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help")])]
            }
          }])
        }, [_vm._v("\n                      Das Bild erscheint in der Navigation.\n                    ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.selectedSeite.bild),
      callback: function($$v) {
        _vm.$set(_vm.selectedSeite, "bild", $$v)
      },
      expression: "selectedSeite.bild"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" Mail Einstellungen ")]), _vm._v(" "), _c('v-row', {
    staticClass: "mb-1"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Absendername",
      "placeholder": "Verein Position"
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "200px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help")])]
            }
          }])
        }, [_vm._v("\n                    Der Absendername wird in Mailprogrammen angezeigt\n                  ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.selectedSeite.sendMail.absender),
      callback: function($$v) {
        _vm.$set(_vm.selectedSeite.sendMail, "absender", $$v)
      },
      expression: "selectedSeite.sendMail.absender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Mailadresse"
    },
    model: {
      value: (_vm.selectedSeite.sendMail.adresse),
      callback: function($$v) {
        _vm.$set(_vm.selectedSeite.sendMail, "adresse", $$v)
      },
      expression: "selectedSeite.sendMail.adresse"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n              An welche Mailadresse sollen Antworten gesendet werden?\n              "), _c('v-radio-group', {
    model: {
      value: (_vm.selectedSeite.sendMail.replyTo),
      callback: function($$v) {
        _vm.$set(_vm.selectedSeite.sendMail, "replyTo", $$v)
      },
      expression: "selectedSeite.sendMail.replyTo"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Absender (Die private Adresse der Person, die die Mail abgeschickt hat.)",
      "value": "absender"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "From (Die Amtsmailadresse, welche oben eingetragen wurde)",
      "value": "from"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("\n            Module\n            "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "max-width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("help")])]
      }
    }])
  }, [_vm._v("\n              Die Module entsprechen den einzelnen Unterseiten und können individuell belegt und angepasst werden.\n            ")])], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-expansion-panels', [_c('draggable', {
    staticClass: "v-item-group theme--light v-expansion-panels",
    model: {
      value: (_vm.selectedSeite.module),
      callback: function($$v) {
        _vm.$set(_vm.selectedSeite, "module", $$v)
      },
      expression: "selectedSeite.module"
    }
  }, _vm._l((_vm.selectedSeite.module), function(modul) {
    return _c('v-expansion-panel', {
      key: modul.id
    }, [_c('v-expansion-panel-header', {
      staticClass: "ma-0 pa-0"
    }, [_c('v-list', {
      staticClass: "elevation-0 pa-0"
    }, [_c('v-list-item', [_c('v-list-item-avatar', [_c('v-icon', [_vm._v(_vm._s(modul.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
      domProps: {
        "innerHTML": _vm._s(modul.name)
      }
    })], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.removeModul(modul)
        }
      }
    }, [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
      staticClass: "pa-0"
    }, [_c('v-text-field', {
      attrs: {
        "label": "Titel",
        "hint": "Dieser Titel wird in der Menüleiste angezeigt."
      },
      model: {
        value: (modul.name),
        callback: function($$v) {
          _vm.$set(modul, "name", $$v)
        },
        expression: "modul.name"
      }
    }), _vm._v(" "), _vm._l((modul.props), function(prop) {
      return _c('div', {
        key: prop
      }, [(prop.name === 'Kasse') ? _c('v-select', {
        attrs: {
          "items": _vm.kassen,
          "label": prop.name,
          "hint": prop.hint
        },
        model: {
          value: (prop.wert),
          callback: function($$v) {
            _vm.$set(prop, "wert", $$v)
          },
          expression: "prop.wert"
        }
      }) : _vm._e(), _vm._v(" "), (prop.name === 'Kalender') ? _c('v-select', {
        attrs: {
          "items": _vm.kalender,
          "label": prop.name,
          "hint": prop.hint,
          "multiple": "",
          "chips": "",
          "deletable-chips": "",
          "clearable": ""
        },
        model: {
          value: (prop.wert),
          callback: function($$v) {
            _vm.$set(prop, "wert", $$v)
          },
          expression: "prop.wert"
        }
      }) : _c('v-text-field', {
        attrs: {
          "label": prop.name,
          "hint": prop.hint
        },
        model: {
          value: (prop.wert),
          callback: function($$v) {
            _vm.$set(prop, "wert", $$v)
          },
          expression: "prop.wert"
        }
      })], 1)
    }), _vm._v(" "), (modul.id === 1) ? _c('v-row', {
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-expansion-panels', [_c('draggable', {
      staticClass: "v-item-group theme--light v-expansion-panels",
      model: {
        value: (modul.submodule),
        callback: function($$v) {
          _vm.$set(modul, "submodule", $$v)
        },
        expression: "modul.submodule"
      }
    }, _vm._l((modul.submodule), function(modul) {
      return _c('v-expansion-panel', {
        key: modul.id
      }, [_c('v-expansion-panel-header', {
        staticClass: "ma-0 pa-0"
      }, [_c('v-list', {
        staticClass: "elevation-0 pa-0"
      }, [_c('v-list-item', [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("unfold_more")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
        domProps: {
          "innerHTML": _vm._s(modul.name)
        }
      })], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', {
        on: {
          "click": function($event) {
            return _vm.removeSubModul(modul)
          }
        }
      }, [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
        staticClass: "pa-0"
      }, [_c('v-text-field', {
        attrs: {
          "label": "Titel",
          "hint": "Dieser Titel wird in der Menüleiste angezeigt."
        },
        model: {
          value: (modul.name),
          callback: function($$v) {
            _vm.$set(modul, "name", $$v)
          },
          expression: "modul.name"
        }
      }), _vm._v(" "), _vm._l((modul.props), function(prop) {
        return _c('div', {
          key: prop
        }, [(prop.name === 'Kasse' || prop.name === 'Konto') ? _c('v-select', {
          attrs: {
            "items": _vm.kassen,
            "label": prop.name,
            "hint": prop.hint
          },
          model: {
            value: (prop.wert),
            callback: function($$v) {
              _vm.$set(prop, "wert", $$v)
            },
            expression: "prop.wert"
          }
        }) : _c('v-text-field', {
          attrs: {
            "label": prop.name,
            "hint": prop.hint
          },
          model: {
            value: (prop.wert),
            callback: function($$v) {
              _vm.$set(prop, "wert", $$v)
            },
            expression: "prop.wert"
          }
        })], 1)
      })], 2)], 1)
    }), 1)], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "my-2",
      attrs: {
        "block": "",
        "outlined": ""
      },
      on: {
        "click": function($event) {
          _vm.showSubModule = true
        }
      }
    }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1) : _vm._e()], 2)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "my-2",
    attrs: {
      "block": "",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.showModule = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showModule),
      callback: function($$v) {
        _vm.showModule = $$v
      },
      expression: "showModule"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "height": "650px"
    }
  }, [_c('v-card-title', [_vm._v("\n            Module\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showModule = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-2"
  }, [_c('v-row', {
    staticClass: "pa-0"
  }, _vm._l((_vm.module), function(modul) {
    return _c('v-col', {
      key: modul.id,
      attrs: {
        "cols": "2"
      }
    }, [_c('v-card', {
      staticClass: "subtitle-2 text-center pt-3 primary",
      attrs: {
        "outlined": "",
        "height": "120px",
        "dark": ""
      },
      on: {
        "click": function($event) {
          return _vm.addModul(modul)
        }
      }
    }, [_c('v-avatar', [_c('v-icon', [_vm._v(_vm._s(modul.icon))])], 1), _vm._v(" "), _c('br'), _vm._v("\n                  " + _vm._s(modul.name) + "\n                ")], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "60%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showSubModule),
      callback: function($$v) {
        _vm.showSubModule = $$v
      },
      expression: "showSubModule"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "height": "650px"
    }
  }, [_c('v-card-title', [_vm._v("\n            Submodule\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showSubModule = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-2"
  }, [_c('v-row', {
    staticClass: "pa-0"
  }, _vm._l((_vm.subModule), function(modul) {
    return _c('v-col', {
      key: modul.id,
      attrs: {
        "cols": "3"
      }
    }, [_c('v-card', {
      staticClass: "subtitle-2 text-center pt-3 primary",
      attrs: {
        "outlined": "",
        "height": "120px",
        "dark": ""
      },
      on: {
        "click": function($event) {
          return _vm.addSubModul(modul)
        }
      }
    }, [_c('v-avatar', [_c('v-icon', [_vm._v(_vm._s(modul.icon))])], 1), _vm._v(" "), _c('br'), _vm._v("\n                  " + _vm._s(modul.name) + "\n                ")], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71da07dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/einstellungenComponents/Rollen.vue
// module id = 791
// module chunks = 15